import { useLocation } from '@tanstack/react-router'
import { type Dict, type Locale, getDict, localeFromPathname, localePath, stripLocale } from '../i18n'

export { localeFromPathname }

/** 現在の URL から言語と辞書を得る */
export function useLocale(): { locale: Locale; t: Dict; path: (p: string) => string; basePath: string } {
  const { pathname } = useLocation()
  const locale = localeFromPathname(pathname)
  return {
    locale,
    t: getDict(locale),
    path: (p: string) => localePath(locale, p),
    basePath: stripLocale(pathname),
  }
}
